import { Either, right, left } from '@shared-commons/utils';
import { GetInstrumentsResponse, GetInstrumentsResponseSchema } from '../types';

// ***** 2. Validator: controlla che i dati "adattati" rispettino lo Zod schema
export const getInstrumentsValidator = (
  data: GetInstrumentsResponse,
): Either<Error, GetInstrumentsResponse> => {
  const parseResult = GetInstrumentsResponseSchema.safeParse(data);
  if (!parseResult.success) {
    // Raccolgo i dettagli dell'errore di validazione
    const errors = parseResult.error.errors
      .map((err) => {
        const path = err.path.join('.');
        const message = err.message;
        return `Campo "${path}": ${message}`;
      })
      .join(' | ');

    return left(new Error(`Errore di validazione (CreateProfile):\n${errors}`));
  }

  // Se tutto OK:
  return right(parseResult.data);
};
